import { useQuery } from "@tanstack/react-query";
import { BosDurum, Buton, Iskelet, Kart, Rozet } from "@koclukpanel/ui";
import { ApiHatasi, personelinOgrencileri } from "../api";

/**
 * PERSONELİN ÖĞRENCİLERİ — Personel 360°
 *
 * ================================================================
 * LİSTE İKİ KAPIDAN GEÇİYOR
 * ================================================================
 * Sunucu hem bu PERSONELİ görme kapsamını hem de ÖĞRENCİ görme
 * kapsamını ayrı ayrı uyguluyor. Bir uzmanı görebilen ama
 * öğrencilerini görmemesi gereken biri için liste boş dönüyor —
 * sekme süzgeci bir kolaylık, koruma sunucuda.
 */

const DURUM_ADI: Record<string, string> = {
  ONBOARDING: "Kayıt sürüyor",
  ACTIVE: "Aktif",
  PAUSED: "Ara verdi",
  LEFT: "Ayrıldı",
  GRADUATED: "Mezun",
};

export function OgrencileriSekmesi({
  personelId,
  personelAdi,
}: {
  personelId: string;
  personelAdi: string;
}) {
  const veri = useQuery({
    queryKey: ["personel-ogrencileri", personelId],
    queryFn: () => personelinOgrencileri(personelId),
    retry: false,
  });

  if (veri.isPending) return <Iskelet satir={4} />;

  if (veri.isError) {
    return (
      <Kart baslik="Öğrencileri">
        <BosDurum
          ton="hata"
          baslik="Liste alınamadı"
          aciklama={veri.error instanceof ApiHatasi ? veri.error.message : undefined}
          eylem={
            <Buton gorunum="ikincil" onClick={() => void veri.refetch()}>
              Tekrar dene
            </Buton>
          }
        />
      </Kart>
    );
  }

  const ogrenciler = veri.data;

  return (
    <Kart
      baslik="Öğrencileri"
      aciklama={`${personelAdi} adlı kişiye şu an atanmış öğrenciler. Ataması sona erenler listede yer almaz.`}
      eylem={<Rozet ton="notr">{ogrenciler.length}</Rozet>}
    >
      {ogrenciler.length === 0 ? (
        /*
          BOŞ LİSTE İKİ ŞEY DEMEK OLABİLİR ve ayırt edemiyoruz: gerçekten
          öğrencisi yok, ya da bizim öğrenci kapsamımız dışındalar.
          Metin ikisini de kapsıyor — "öğrencisi yok" demek, ikinci
          durumda YANLIŞ bir bilgi olurdu.
        */
        <p className="text-notr-700 text-sm">
          Yetkiniz dahilinde görüntülenebilecek atanmış öğrenci yok.
        </p>
      ) : (
        <ul className="flex flex-col">
          {ogrenciler.map((o) => (
            <li
              key={o.id}
              className="border-notr-200 flex flex-wrap items-baseline justify-between gap-2 border-b py-2 last:border-b-0"
            >
              <span className="text-notr-900 text-sm">
                <span className="text-notr-600 tabular-nums">#{o.studentNo}</span> {o.ad} {o.soyad}
              </span>
              <Rozet ton={o.status === "ACTIVE" ? "onay" : "notr"}>
                {DURUM_ADI[o.status] ?? o.status}
              </Rozet>
            </li>
          ))}
        </ul>
      )}
    </Kart>
  );
}
